import { render, staticRenderFns } from "./EmployeeStats.vue?vue&type=template&id=4ab824c7&scoped=true&"
import script from "./EmployeeStats.vue?vue&type=script&lang=js&"
export * from "./EmployeeStats.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeStats.vue?vue&type=style&index=0&id=4ab824c7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab824c7",
  null
  
)

export default component.exports